const Minesdata = [
    {
        id : "1",
        schemeName: "Pradhan Mantri Khanji Kshetra Kalyan Yojana.",
        discription:"The Ministry of Mines launched Pradhan Mantri Khanij Kshetra Kalyan Yojana (PMKKKY) in 2015 for the welfare of areas and people affected by mining-related operations, using the funds generated by District Mineral Foundations (DMFs).",
        launchDate: "Year 2015",
        AnualFund: "12345"

    },
]
export default Minesdata;